import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';

import './block-profit.scss';

class BlockProfit extends PureComponent {
  render() {
    return (
      <div className="block-profit">
        <div className="block-value">
          +{this.props.profitRate}%
        </div>

        <div className="block-text">
          Ставка купонного дохода на {this.props.rateDate}
        </div>
      </div>
    );
  }
}

BlockProfit.propTypes = {
  profitRate: PropTypes.string,
  rateDate: PropTypes.string
};

export default BlockProfit;



// WEBPACK FOOTER //
// ./src/components/SuccessStory/BlockProfit.js